import { useState, useCallback } from 'react';
import { FetchElements } from "../../../../../utils/js/request";
import { useNavigate } from "react-router-dom";
import { REQUEST, GET_SELECTED_SHOP_ID } from "../../../../../utils/js/Const";

export const useBakeryAddProduct = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const updateTask = useCallback(async (productions_tasks_guid, users_guid, quantity) => {
        setLoading(true);
        setError(null);

        const url = `${REQUEST}/api/v1/productions/tasks`;

        const body = {
            productions_tasks_guid: productions_tasks_guid,
            users_guid: users_guid,
            quantity: quantity
        };

        return new Promise((resolve, reject) => {
            FetchElements(
                url,
                "PATCH",
                (responseData) => {
                    setLoading(false);
                    resolve(responseData);
                },
                navigate,
                2,
                () => navigate("/auth"),
                (title, message, statusCode) => {
                    const errorObj = { title, message, statusCode };
                    setError(errorObj);
                    setLoading(false);
                    reject(errorObj);
                    console.error(`${title}: ${message}`);
                },
                0,
                body,
                [],
                false
            );
        });
    }, [navigate]);

    const createTask = useCallback(async (goods_id, users_guid, quantity) => {
        setLoading(true);
        setError(null);

        const selectedId = GET_SELECTED_SHOP_ID();
        const url = `${REQUEST}/api/v1/productions/tasks`;

        if (!goods_id) {
            console.error('goods_id не может быть null');
            setLoading(false);
            return Promise.reject({ message: 'goods_id не может быть null' });
        }

        const body = {
            goods_id: Number(goods_id),
            quantity: Number(quantity),
            shops_id: Number(selectedId),
            users_guid: users_guid
        };

        return new Promise((resolve, reject) => {
            FetchElements(
                url,
                "POST",
                (responseData) => {
                    setLoading(false);
                    resolve(responseData);
                },
                navigate,
                2,
                () => navigate("/auth"),
                (title, message, statusCode) => {
                    const errorObj = { title, message, statusCode };
                    setError(errorObj);
                    setLoading(false);
                    reject(errorObj);
                    console.error(`${title}: ${message}`);
                },
                0,
                body,
                [],
                false
            );
        });
    }, [navigate]);

    const addProduct = useCallback(async (goods_id, quantity, users_guid, task_guid = null) => {
        if (!users_guid) {
            console.warn('Пользователь не выбран');
            return { success: false, error: 'Выберите пользователя' };
        }

        if (task_guid) {
            return updateTask(task_guid, users_guid, quantity);
        }

        return createTask(goods_id, users_guid, quantity);
    }, [updateTask, createTask]);

    return { addProduct, updateTask, createTask, loading, error };
};